import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from '@drl/core/component-base';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { GetAppoinmentModel } from '@drl/shared/models';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { AppoinmentService } from '../appoinment.service';
import {
  CONSTANTSSTATUS,
  CONSTSFGENTYPE,
} from '../dialog-edit-appointment/flags.const';
import { UserStatus, userStatusTypesMap } from '@drl/core/enums/user-status.enum';
import { environment } from '@drl/env/environment';
@Component({
  selector: 'app-dialog-chat',
  templateUrl: './dialog-chat.component.html',
  styleUrls: ['./dialog-chat.component.scss'],
})
export class DialogChatComponent extends ComponentBase {
  readonly CONSTANTS = CONSTANTSSTATUS;
  readonly CONSTGENTYPE = CONSTSFGENTYPE;
  readonly brand = environment.brand;
  user: GetAppoinmentModel;
  loading = false;
  ptsDetailsById;
  appointmentId;
  age;
  IsEdit;
  resNurshingNotes;
  careGiverGroupDetails;
  attendeeDetails;
  public ptsImageUrlChat;
  attendeeDefaultImage = '../../../../assets/patient-avatar.png';
  guestAge;
  guestGender;
  alternativeContactDetails;
  statuses = [];
  maleTextLbl: string;
  femaleTextLbl: string;
  otherLbl: string;
  constructor(
    public dialogRef: NbDialogRef<DialogChatComponent>,
    public readonly patientService: AppoinmentService,
    private readonly router: Router,
    protected readonly translateSvc: IpsTranslateService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;
  ngOnInit() {
    this.getTranslations();
    this.appointmentId = this.user.id;
    if (this.user.patientImageUrl != null && this.user.patientImageUrl) {
      this.ptsImageUrlChat = this.user.patientImageUrl;
    } else if (this.user.patientImg != null && this.user.patientImg) {
      this.ptsImageUrlChat = this.user.patientImg;
    } else {
      this.ptsImageUrlChat = this.attendeeDefaultImage;
    }
    this.getPatientsDetails();
    this.appointmentId = this.user.id;
    if (this.user.patientType === 'guest_patient') {
      this.guestAgeGender(this.user.id);
    }
    // this.getAlternativeEmailAndMob(this.appointmentId);// Commenting for MVP
    this.getAttendeeList(this.appointmentId);
    this.getNurshingNotes(this.appointmentId);
  }
  /* getAlternativeEmailAndMob(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAlternativeEmailAndMob(body).subscribe(res => {
      this.alternativeContactDetails = res.responseResult;
    });
  } */ // Commenting for MVP
  guestAgeGender(guestID: number): void {
    const gID = {
      appointmentId: guestID,
    };
    this.patientService.getPatientsDetailsById(gID).subscribe(res => {
      this.guestAge = res.responseResult.age;
      this.guestGender = res.responseResult.gender.trim();
    });
  }
  getPatientsDetails() {
    this.loading = false;
    this.patientService.getPatients().subscribe(res => {
      this.ptsDetailsById = res;
      this.ptsDetailsById = this.ptsDetailsById.find(
        x => x.id === this.user.patientId,
      );
      this.age = this.ageFromDateOfBirthday(this.ptsDetailsById.dob);
      this.getCaregiverGroup(this.ptsDetailsById.careGroupId);
      this.loading = true;
    });
  }
  public ageFromDateOfBirthday(dateOfBirth): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  getNurshingNotes(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getNurshingNotes(body).subscribe(res => {
      if (res.responseMessage === 'Success') {
        this.resNurshingNotes = res.responseResult;
      }
    });
  }
  getCaregiverGroup(body: string) {
    this.loading = true;
    this.patientService.getCaregiverGroup(body).subscribe(res => {
      this.careGiverGroupDetails = res;
      this.loading = false;
    });
  }
  getAttendeeList(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAttendeeList(body).subscribe(res => {
      this.attendeeDetails = res.responseResult;
    });
  }
  getTranslations() {
    this.translate
      .get(['maleTextLbl', 'femaleTextLbl', 'otherLbl'])
      .subscribe(res => {
        this.statuses = [
          userStatusTypesMap(this.translate)[UserStatus.REGISTERED],
          userStatusTypesMap(this.translate)[UserStatus.ACTIVE],
          userStatusTypesMap(this.translate)[UserStatus.INACTIVE],
        ];

        this.maleTextLbl = res.maleTextLbl;
        this.femaleTextLbl = res.femaleTextLbl;
        this.otherLbl = res.otherLbl;
      });
  }
  public getGenderLbl(genderLbl: string) {
    if (
      genderLbl === this.CONSTGENTYPE.Male ||
      genderLbl === this.CONSTGENTYPE.GMale
    ) {
      return this.maleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Female ||
      genderLbl === this.CONSTGENTYPE.GFemale
    ) {
      return this.femaleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Other ||
      genderLbl === this.CONSTGENTYPE.GOther
    ) {
      return this.otherLbl;
    } else {
      return null;
    }
  }
}
